import { useState } from "react";
import { ChevronUpIcon } from "@heroicons/react/solid";

type CollapsibleSectionProps = {
  title: React.ReactNode;
  className?: string;
  children: React.ReactNode;
};

const CollapsibleSection = ({ title, className, children }: CollapsibleSectionProps) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={className}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        className="flex items-center gap-2 text-left"
      >
        <ChevronUpIcon
          className={`h-4 w-4 shrink-0 text-gray-500 transition-transform ${
            open ? "" : "rotate-180"
          }`}
        />
        <span className="text-sm font-medium text-gray-700">{title}</span>
      </button>
      {open && children}
    </div>
  );
};

export default CollapsibleSection;
